import type { UserWorkspaceTypeEnum } from 'gql/graphql'

export type UserWorkspaceRole = UserWorkspaceTypeEnum

export const userWorkspaceRoles = [
  'owner',
  'editor',
  'viewer',
  'financialViewer',
] as const satisfies readonly UserWorkspaceRole[]
